import {Provider} from '@angular/core';

// Injection token for the Http Interceptors multi-provider
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {LoginTokenInterceptor} from "./login.token.interceptor";
import {HttpErrorInterceptor} from "./http.error.interceptor";

/** Provider for the Noop Interceptor. */
export const loginTokenInterceptorProvider: Provider =
  {provide: HTTP_INTERCEPTORS, useClass: LoginTokenInterceptor, multi: true};

export const unauthorizedInterceptorProvider: Provider =
  {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true};
